import React, { useMemo, memo, useState, useEffect } from 'react';
import style from './index.module.scss';
import { getIPList } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import { Spin, Empty, Checkbox } from 'antd';
// import type { InferArrayValue } from '@/types/infer';
import { languageMap } from '@/locale';
import { useTranslation } from 'react-i18next';
import FatorBox from '../../components/FatorBox';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';

interface Props {
  initValue: number[];
  changeFator: (fator: { ip_id__in: string | undefined }) => void;
}

const IPList: React.FC<Props> = ({ changeFator, initValue }) => {
  const { i18n, t } = useTranslation();
  const [value, setValue] = useState<number[]>([]);
  const { data: ipList, isFetching } = useQuery([getIPList.name], async () => {
    const res = await getIPList({
      page: 1,
      page_size: 500,
    });
    const list = res.data!.list || [];
    return list.filter((item) => item.status === 1);
  });
  const checkList = useMemo(() => {
    if (ipList && ipList.length) {
      return ipList.map((item) => ({
        label: `${item[languageMap[i18n.language]]}`,
        value: item.id || 0,
      }));
    }
    return [];
  }, [ipList, i18n.language]);
  const changeIP = (ips: CheckboxValueType[]) => {
    setValue(ips as number[]);
    changeFator({
      ip_id__in: ips.join(','),
    });
  };
  const reload = () => {
    setValue([]);
    changeFator({
      ip_id__in: undefined,
    });
  };
  useEffect(() => {
    setValue(initValue);
  }, [initValue]);
  return (
    <FatorBox title={t('mall.ip')} reload={reload}>
      <div className={style.ips}>
        <Spin className="center-loading" delay={300} spinning={isFetching} />
        {ipList && ipList.length > 0 && (
          <Checkbox.Group
            className={style.group}
            options={checkList}
            onChange={changeIP}
            defaultValue={initValue}
            value={value}
          />
        )}
        {ipList && ipList.length === 0 && <Empty />}
      </div>
    </FatorBox>
  );
};

export default memo(IPList);
